import groupBy from "lodash/groupBy";
import uniqBy from "lodash/uniqBy";
import values from "lodash/values";
import {
  LocationApiItem,
  LocationApiItemName,
  LocationApiResponse,
} from "../dtos";
import { State } from "../models";

export enum StatesAbbr {
  ac = "Acre",
  al = "Alagoas",
  am = "Amazonas",
  ap = "Amapá",
  ba = "Bahia",
  ce = "Ceará",
  df = "Distrito Federal",
  es = "Espírito Santo",
  go = "Goiás",
  ma = "Maranhão",
  mg = "Minas Gerais",
  ms = "Mato Grosso do Sul",
  mt = "Mato Grosso",
  pa = "Pará",
  pb = "Paraíba",
  pe = "Pernambuco",
  pi = "Piauí",
  pr = "Paraná",
  rj = "Rio de Janeiro",
  rn = "Rio Grande do Norte",
  ro = "Rondônia",
  rr = "Roraima",
  rs = "Rio Grande do Sul",
  sc = "Santa Catarina",
  sp = "São Paulo",
  se = "Sergipe",
  to = "Tocantins",
}

export abstract class StateTransformer {
  /**
   * Get state name by abbr
   *
   * @param abbr
   * @returns
   */
  static transformAbbrToStateName(abbr: string): string | null {
    const formattedAbbr = abbr.toLowerCase() as keyof typeof StatesAbbr;

    return StatesAbbr[formattedAbbr] ?? null;
  }

  /**
   * Transform the location api response item into a state model
   *
   * @param data
   * @returns
   */
  static transform(data: LocationApiResponse): State[] {
    const groupedStates = groupBy(data, (stateDto) => {
      const apiItem: LocationApiItemName = JSON.parse(stateDto.Name);

      return apiItem.State.toLocaleLowerCase();
    });

    return values(groupedStates).map((stateDtos: LocationApiItem[]) => {
      const state: State = {
        name: "",
        count: 0,
        abbr: "",
        cities: [],
      };

      for (const stateDto of stateDtos) {
        const cityDto: LocationApiItemName = JSON.parse(stateDto.Name);

        state.name = cityDto.State;
        state.count = state.count + stateDto.Count;
        state.abbr = cityDto.Abbr;

        const city = {
          latitude: cityDto.Latitude,
          longitude: cityDto.Longitude,
          name: cityDto.City,
          count: stateDto.Count,
        };

        state.cities.push(city);
      }

      state.cities = uniqBy(
        state.cities,
        ({ name, state }) => `${name}-${state?.abbr ?? ""}`
      );

      return state;
    });
  }
}
